export enum DELIVERY_GRADE_TYPE {
  RESTAURANT_ONLY = 'RESTAURANT_ONLY',
  RESTAURANT_OR_DELIVERY = 'RESTAURANT_OR_DELIVERY',
  DELIVERY_ONLY = 'DELIVERY_ONLY',
}

export const CONST_DELIVERY_GRADE_TYPE = Object.values(DELIVERY_GRADE_TYPE);
